import * as Immutable from "immutable";
import VisualizationConfig from "./VisualizationConfig";
import Viewport from "./Viewport";
export default class WorldMapVisualizationConfig extends VisualizationConfig {
  constructor(viewport) {
    super();
    this._value = { viewport };
  }
  get viewport() {
    return this._value.viewport;
  }
  toBuilder() {
    const { viewport } = this._value;
    return new Builder(Immutable.Map({ viewport }));
  }
  static create(viewport) {
    return new WorldMapVisualizationConfig(viewport);
  }
  toJSON() {
    const { viewport } = this._value;
    return {
      viewport
    };
  }
  static fromJSON(_type, value) {
    const { viewport } = value;
    return WorldMapVisualizationConfig.builder().viewport(Viewport.fromJSON(viewport)).build();
  }
  static builder() {
    return new Builder();
  }
}
class Builder {
  constructor(value = Immutable.Map()) {
    this.value = value;
  }
  viewport(value) {
    return new Builder(this.value.set("viewport", value));
  }
  build() {
    const { viewport } = this.value.toObject();
    return new WorldMapVisualizationConfig(viewport);
  }
}
